import React, { Component } from 'react';
import Swal from 'sweetalert2';
import Autenticado from '../../components/Autenticado';
import spinner from '../../img/spinner.gif';
import { prevalidarBajasEmpleados, confirmarBajasEmpleados } from '../../api/Empleados';
import EmpresasSelect from '../../components/EmpresasSelect';

const PASOS = [
  { numero: 1, nombre: 'Cargar Archivo', icono: 'fa-cloud-upload' },
  { numero: 2, nombre: 'Previsualización', icono: 'fa-eye' },
  { numero: 3, nombre: 'Resultado', icono: 'fa-flag-checkered' }
];

const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2 MB
const EXTENSIONES_VALIDAS = ['.xlsx', '.xls', '.csv'];
const MIME_TYPES_VALIDOS = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel',
  'text/csv'
];

const COLUMNAS_PLANTILLA_BAJAS = [
  'curp',
  'nombre',
  'apellido_paterno',
  'apellido_materno',
  'no_empleado'
];

class BajasMasivas extends Component {
  state = {
    titulo: 'Bajas Masivas',
    pasoActual: 1,
    archivo: null,
    nombreArchivo: '',
    tamanoArchivo: '',
    empresa: null,
    empresaSelect: null,
    exitosos: 0,
    fallidos: 0,
    resultadosExitosos: [],
    resultadosFallidos: [],
    errorBackend: null,
    errores: [],
    previewError: null,
    previewResumen: { total_filas: 0, listos_procesar: 0, con_error: 0 },
    previewFilasListas: [],
    previewFilasError: [],
    previewEmpresaRespuesta: null,
    curpsParaConfirmar: []
  };

  cargando = (texto = 'Procesando, espera un momento por favor...') => {
    Swal.fire({
      text: texto,
      showConfirmButton: false,
      position: 'center',
      allowOutsideClick: false,
      allowEscapeKey: false,
      imageUrl: spinner,
      imageWidth: 100,
      imageHeight: 100,
      imageAlt: 'Espera un momento'
    });
  };

  mostrarToast = (mensaje, tipo = 'success') => {
    Swal.fire({
      type: tipo,
      text: mensaje,
      toast: true,
      position: 'top-end',
      timer: 3000,
      showConfirmButton: false
    });
  };

  cerrarAlertas = () => {
    Swal.close();
  };

  formatearTamano = (bytes) => {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
  };

  handleFileChange = e => {
    const file = e.target.files[0];
    if (file) {
      this.setState({
        archivo: file,
        nombreArchivo: file.name,
        tamanoArchivo: this.formatearTamano(file.size),
        errores: []
      });
    } else {
      this.setState({ archivo: null, nombreArchivo: '', tamanoArchivo: '' });
    }
  };

  leerBytesArchivo = (archivo, numBytes) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        resolve(new Uint8Array(e.target.result));
      };
      reader.onerror = () => reject(new Error('No se pudo leer el archivo.'));
      reader.readAsArrayBuffer(archivo.slice(0, numBytes));
    });
  };

  validarContenidoArchivo = async () => {
    const { archivo, empresa } = this.state;
    const errores = [];

    if (!empresa) {
      errores.push('Selecciona una empresa por favor.');
    }

    if (!archivo) {
      errores.push('Selecciona un archivo por favor.');
      this.setState({ errores });
      return false;
    }

    const extension = '.' + archivo.name.split('.').pop().toLowerCase();
    if (!EXTENSIONES_VALIDAS.includes(extension)) {
      errores.push(`Tipo de archivo no válido (${extension}). Solo se aceptan: ${EXTENSIONES_VALIDAS.join(', ')}`);
    }

    if (archivo.size === 0) {
      errores.push('El archivo está vacío.');
    }

    if (archivo.size > MAX_FILE_SIZE) {
      errores.push(`El archivo excede el límite de 2 MB (${this.formatearTamano(archivo.size)}).`);
    }

    if (errores.length === 0) {
      try {
        const bytes = await this.leerBytesArchivo(archivo, 4);
        const esXlsx = bytes[0] === 0x50 && bytes[1] === 0x4B && bytes[2] === 0x03 && bytes[3] === 0x04;
        const esXls = bytes[0] === 0xD0 && bytes[1] === 0xCF && bytes[2] === 0x11 && bytes[3] === 0xE0;

        if (extension === '.csv') {
          const bytesCsv = await this.leerBytesArchivo(archivo, 1024);
          const texto = String.fromCharCode.apply(null, bytesCsv);
          const esTexto = /^[\x20-\x7E\r\n\t,;|"'áéíóúñÁÉÍÓÚÑüÜ]+$/i.test(texto);
          if (!esTexto) {
            errores.push('El archivo no parece ser un CSV válido.');
          }
        } else if (!esXlsx && !esXls) {
          errores.push('El contenido del archivo no corresponde a un Excel válido.');
        }
      } catch (err) {
        errores.push('No se pudo verificar el archivo.');
      }
    }

    this.setState({ errores });
    return errores.length === 0;
  };

  estadoVacioPreview = () => ({
    previewError: null,
    previewResumen: { total_filas: 0, listos_procesar: 0, con_error: 0 },
    previewFilasListas: [],
    previewFilasError: [],
    previewEmpresaRespuesta: null,
    curpsParaConfirmar: []
  });

  irAValidacionServidor = async () => {
    const valido = await this.validarContenidoArchivo();
    if (!valido) return;

    const { archivo, empresa } = this.state;
    this.setState({ errores: [] });
    this.cargando('Validando archivo, espera un momento...');
    const formData = new FormData();
    formData.append('archivo', archivo);
    formData.append('empresa', empresa);

    try {
      const resp = await prevalidarBajasEmpleados(formData);
      const data = resp.data;
      const errorText =
        data.error != null && String(data.error).trim() !== ''
          ? String(data.error).trim()
          : null;

      const falloNivelArchivo =
        data.prevalidado === false ||
        data.procesado === false ||
        errorText != null;

      if (falloNivelArchivo) {
        const mensaje = errorText || 'No se pudo prevalidar el archivo.';
        this.setState({
          errores: [mensaje],
          pasoActual: 1,
          ...this.estadoVacioPreview()
        });
        this.cerrarAlertas();
        return;
      }

      const filasListas = data.filas_listas || [];
      const curps = filasListas
        .map(f => (f.curp != null ? String(f.curp).trim() : ''))
        .filter(c => c.length > 0);
      const resumen = data.resumen || {};
      this.setState({
        errores: [],
        previewError: null,
        previewResumen: {
          total_filas: resumen.total_filas || 0,
          listos_procesar: resumen.listos_procesar || 0,
          con_error: resumen.con_error || 0
        },
        previewFilasListas: filasListas,
        previewFilasError: data.filas_error || [],
        previewEmpresaRespuesta: data.empresa || null,
        curpsParaConfirmar: curps,
        pasoActual: 2
      });
      this.cerrarAlertas();
    } catch (err) {
      this.cerrarAlertas();
      const data = err.data || {};
      const msg =
        (data.error && String(data.error)) ||
        data.detail ||
        (typeof data === 'string' ? data : null) ||
        err.message ||
        'Error al prevalidar el archivo';
      this.setState({
        errores: [msg],
        pasoActual: 1,
        ...this.estadoVacioPreview()
      });
    }
  };

  volverAPaso1 = () => {
    this.setState({
      pasoActual: 1,
      errores: [],
      ...this.estadoVacioPreview()
    });
  };

  confirmarYEnviar = async () => {
    const { empresa, curpsParaConfirmar } = this.state;
    if (!empresa) {
      this.mostrarToast('Selecciona una empresa.', 'error');
      return;
    }
    if (!curpsParaConfirmar || curpsParaConfirmar.length === 0) {
      this.mostrarToast('No hay CURPs válidos para confirmar.', 'error');
      return;
    }

    const result = await Swal.fire({
      title: '¿Estás seguro?',
      text: 'Se aplicarán las bajas en base de datos para los empleados indicados. Esta acción no se puede deshacer.',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sí, proceder',
      cancelButtonText: 'Cancelar'
    });

    if (!result.value) return;

    this.cargando();
    try {
      const resp = await confirmarBajasEmpleados({
        empresa,
        curps: curpsParaConfirmar
      });
      const { procesado, error, exitosos, fallidos, resultados_exitosos, resultados_fallidos } = resp.data;

      if (!procesado) {
        this.setState({
          errorBackend: error,
          exitosos: 0,
          fallidos: 0,
          resultadosExitosos: [],
          resultadosFallidos: [],
          pasoActual: 3
        });
        this.cerrarAlertas();
        return;
      }

      this.setState({
        errorBackend: null,
        exitosos: exitosos || 0,
        fallidos: fallidos || 0,
        resultadosExitosos: resultados_exitosos || [],
        resultadosFallidos: resultados_fallidos || [],
        pasoActual: 3
      });
      this.cerrarAlertas();
    } catch (error) {
      this.cerrarAlertas();
      this.mostrarToast(error.message || 'Error al procesar las bajas', 'error');
    }
  };

  descargarPlantillaBajas = () => {
    const filas = [COLUMNAS_PLANTILLA_BAJAS];
    const csv = filas.map(f =>
      f.map(campo => `"${String(campo).replace(/"/g, '""')}"`).join(',')
    ).join('\r\n');

    const bom = '\uFEFF';
    const blob = new Blob([bom + csv], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'plantilla_bajas_masivas_empleados.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  descargarResultados = () => {
    const { resultadosExitosos, resultadosFallidos } = this.state;
    const filas = [['Nombre', 'Estatus', 'Detalle']];

    resultadosExitosos.forEach(res => {
      filas.push([res.nombre || '', 'Exitoso', res.mensaje || 'Dado de baja correctamente.']);
    });

    resultadosFallidos.forEach(res => {
      filas.push([res.nombre || '', 'Fallido', res.error || '']);
    });

    const csv = filas.map(f =>
      f.map(campo => `"${String(campo).replace(/"/g, '""')}"`).join(',')
    ).join('\r\n');

    const bom = '\uFEFF';
    const blob = new Blob([bom + csv], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `bajas_masivas_resultados_${new Date().toISOString().slice(0, 10)}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  empresaChange = (e) => {
    if (!e || e.value === '') {
      this.setState({ empresa: null, empresaSelect: null });
      return;
    }
    this.setState({ empresa: e.value, empresaSelect: e });
  };

  reiniciar = () => {
    this.setState({
      pasoActual: 1,
      archivo: null,
      nombreArchivo: '',
      tamanoArchivo: '',
      empresa: null,
      empresaSelect: null,
      exitosos: 0,
      fallidos: 0,
      resultadosExitosos: [],
      resultadosFallidos: [],
      errorBackend: null,
      errores: [],
      previewError: null,
      previewResumen: { total_filas: 0, listos_procesar: 0, con_error: 0 },
      previewFilasListas: [],
      previewFilasError: [],
      previewEmpresaRespuesta: null,
      curpsParaConfirmar: []
    });
  };

  renderStepper() {
    const { pasoActual } = this.state;
    return (
      <div className="stepper-vertical">
        {PASOS.map((paso, index) => (
          <div
            key={paso.numero}
            className={`stepper-step${pasoActual === paso.numero ? ' active' : ''}${pasoActual > paso.numero ? ' completed' : ''}`}
          >
            <div className="stepper-circle">
              {pasoActual > paso.numero ? (
                <i className="fa fa-check" />
              ) : (
                <span>{paso.numero}</span>
              )}
            </div>
            <div className="stepper-label">
              <span className="stepper-title">{paso.nombre}</span>
            </div>
            {index < PASOS.length - 1 && <div className="stepper-line" />}
          </div>
        ))}
      </div>
    );
  }

  renderPaso1() {
    const { errores, nombreArchivo, tamanoArchivo, empresaSelect } = this.state;
    return (
      <div className="ibox">
        <div className="ibox-content">
          <div className="form-group">
            <label><strong>Empresa</strong> <span className="text-danger">*</span></label>
            <div style={{ maxWidth: '400px' }}>
              <EmpresasSelect onChange={this.empresaChange} value={empresaSelect} />
            </div>
          </div>
          <div className="text-center" style={{ padding: '30px' }}>
            <div className="dropzone-area">
              <i className="fa fa-cloud-upload fa-3x text-muted" />
              <h4>Selecciona tu archivo</h4>
              <p className="text-muted">Formatos aceptados: .xlsx, .xls, .csv — Máximo 2 MB</p>
              <input
                type="file"
                className="form-control"
                accept=".xlsx,.csv,.xls"
                onChange={this.handleFileChange}
                style={{ maxWidth: '400px', margin: '0 auto' }}
              />
              {nombreArchivo && (
                <p className="m-t-sm text-success">
                  <i className="fa fa-file-excel-o" /> {nombreArchivo} ({tamanoArchivo})
                </p>
              )}
              {errores.length > 0 && errores.map((err, index) => (
                <p className="text-danger m-t-xs m-b-none" key={`err${index}`}>
                  <i className="fa fa-exclamation-circle" /> {err}
                </p>
              ))}
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-sm-6">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={this.descargarPlantillaBajas}
              >
                <i className="fa fa-download fa-margin" />
                Descargar plantilla
              </button>
            </div>
            <div className="col-sm-6 text-right">
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={this.irAValidacionServidor}
              >
                Siguiente <i className="fa fa-arrow-right" />
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderPaso2() {
    const {
      nombreArchivo,
      tamanoArchivo,
      empresaSelect,
      previewError,
      previewResumen,
      previewFilasListas,
      previewFilasError,
      previewEmpresaRespuesta,
      curpsParaConfirmar
    } = this.state;

    const empresaNombre =
      (previewEmpresaRespuesta && previewEmpresaRespuesta.nombre) ||
      (empresaSelect && empresaSelect.label) ||
      '--';

    const puedeProcesar = !previewError && curpsParaConfirmar.length > 0;

    return (
      <div className="ibox">
        <div className="ibox-content">
          <div className="alert alert-info">
            <i className="fa fa-info-circle" />{' '}
            <strong>Vista previa:</strong> aún no se aplican cambios en la base de datos.
            Revisa los registros válidos y con error antes de confirmar.
          </div>

          <h4>Empresa</h4>
          <div className="well well-sm">
            <i className="fa fa-building text-muted" />{' '}
            <strong>{empresaNombre}</strong>
          </div>

          <h4>Archivo</h4>
          <div className="well well-sm">
            <i className="fa fa-file-excel-o text-success" />{' '}
            <strong>{nombreArchivo}</strong> ({tamanoArchivo})
          </div>

          {previewError && (
            <div className="alert alert-danger m-t-md">
              <i className="fa fa-times-circle" /> <strong>No se pudo prevalidar el archivo:</strong>{' '}
              {previewError}
            </div>
          )}

          {!previewError && (
            <>
              <div className="row text-center m-b-lg m-t-md">
                <div className="col-sm-4">
                  <h2>{previewResumen.total_filas}</h2>
                  <p className="text-muted">Total filas</p>
                </div>
                <div className="col-sm-4">
                  <h2 className="text-success">{previewResumen.listos_procesar}</h2>
                  <p className="text-muted">Listos para procesar</p>
                </div>
                <div className="col-sm-4">
                  <h2 className="text-danger">{previewResumen.con_error}</h2>
                  <p className="text-muted">Con error</p>
                </div>
              </div>

              {previewFilasListas.length > 0 && (
                <div>
                  <h4 className="text-success">
                    <i className="fa fa-check-circle" /> Listos para procesar ({previewFilasListas.length})
                  </h4>
                  <div className="tabla-scroll">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>Fila</th>
                          <th>Nombre</th>
                          <th>CURP</th>
                          <th>No. empleado</th>
                        </tr>
                      </thead>
                      <tbody>
                        {previewFilasListas.map((fila, index) => (
                          <tr key={`pvOk${index}`}>
                            <td>{fila.numero_fila != null ? fila.numero_fila : '--'}</td>
                            <td>{fila.nombre || '--'}</td>
                            <td>{fila.curp || '--'}</td>
                            <td>{fila.no_empleado || '--'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {previewFilasError.length > 0 && (
                <div className={previewFilasListas.length > 0 ? 'm-t-lg' : ''}>
                  <h4 className="text-danger">
                    <i className="fa fa-times-circle" /> Con error ({previewFilasError.length})
                  </h4>
                  <div className="tabla-scroll">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>Fila</th>
                          <th>Nombre</th>
                          <th>CURP</th>
                          <th>No. empleado</th>
                          <th>Error</th>
                        </tr>
                      </thead>
                      <tbody>
                        {previewFilasError.map((fila, index) => (
                          <tr key={`pvErr${index}`}>
                            <td>{fila.numero_fila != null ? fila.numero_fila : '--'}</td>
                            <td>{fila.nombre || '--'}</td>
                            <td>{fila.curp || '--'}</td>
                            <td>{fila.no_empleado || '--'}</td>
                            <td className="text-danger">{fila.error || '--'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </>
          )}

          <hr />
          <div className="row">
            <div className="col-sm-6">
              <button
                type="button"
                className="btn btn-sm btn-default"
                onClick={this.volverAPaso1}
              >
                <i className="fa fa-arrow-left fa-margin" />
                Anterior
              </button>
            </div>
            <div className="col-sm-6 text-right">
              <button
                type="button"
                className="btn btn-sm btn-danger"
                onClick={this.confirmarYEnviar}
                disabled={!puedeProcesar}
                title={!puedeProcesar ? 'Corrige el archivo o elige otra empresa' : ''}
              >
                <i className="fa fa-user-times fa-margin" />
                Confirmar y aplicar bajas
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderPaso3() {
    const { exitosos, fallidos, resultadosExitosos, resultadosFallidos, errorBackend } = this.state;

    if (errorBackend) {
      return (
        <div className="ibox">
          <div className="ibox-content">
            <div className="alert alert-danger text-center">
              <i className="fa fa-times-circle fa-3x m-b-sm" />
              <h3>No se procesó el archivo</h3>
              <p>{errorBackend}</p>
            </div>
            <hr />
            <div className="text-center">
              <button
                type="button"
                className="btn btn-sm btn-primary"
                onClick={this.reiniciar}
              >
                <i className="fa fa-refresh fa-margin" />
                Intentar de nuevo
              </button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="ibox">
        <div className="ibox-content">
          <div className="row m-b-sm">
            <div className="col-sm-12 text-right">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={this.descargarResultados}
              >
                <i className="fa fa-download fa-margin" />
                Descargar resultados
              </button>
            </div>
          </div>
          <div className="row text-center m-b-lg">
            <div className="col-sm-4">
              <h2>{exitosos + fallidos}</h2>
              <p className="text-muted">Procesados</p>
            </div>
            <div className="col-sm-4">
              <h2 className="text-success">{exitosos}</h2>
              <p className="text-muted">Exitosos</p>
            </div>
            <div className="col-sm-4">
              <h2 className="text-danger">{fallidos}</h2>
              <p className="text-muted">Fallidos</p>
            </div>
          </div>

          {resultadosExitosos.length > 0 && (
            <div>
              <h4 className="text-success">
                <i className="fa fa-check-circle" /> Dados de baja ({exitosos})
              </h4>
              <div className="tabla-scroll">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Nombre</th>
                      <th>Mensaje</th>
                    </tr>
                  </thead>
                  <tbody>
                    {resultadosExitosos.map((res, index) => (
                      <tr key={`ex${index}`}>
                        <td>{res.nombre || '--'}</td>
                        <td>{res.mensaje || 'Dado de baja correctamente.'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {resultadosFallidos.length > 0 && (
            <div className={resultadosExitosos.length > 0 ? 'm-t-lg' : ''}>
              <h4 className="text-danger">
                <i className="fa fa-times-circle" /> Fallidos ({fallidos})
              </h4>
              <div className="tabla-scroll">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Nombre</th>
                      <th>Error</th>
                    </tr>
                  </thead>
                  <tbody>
                    {resultadosFallidos.map((res, index) => (
                      <tr key={`fa${index}`}>
                        <td>{res.nombre || '--'}</td>
                        <td className="text-danger">{res.error || '--'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <hr />
          <div className="text-center">
            <button
              type="button"
              className="btn btn-sm btn-primary"
              onClick={this.reiniciar}
            >
              <i className="fa fa-refresh fa-margin" />
              Realizar nuevas bajas
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderContenidoPaso() {
    const { pasoActual } = this.state;
    switch (pasoActual) {
      case 1: return this.renderPaso1();
      case 2: return this.renderPaso2();
      case 3: return this.renderPaso3();
      default: return this.renderPaso1();
    }
  }

  render() {
    const { titulo } = this.state;
    const guia = [
      { nombre: 'Empleados', url: '/empleados', clase: '' },
      { nombre: titulo, url: '', clase: 'active' }
    ];

    return (
      <Autenticado titulo={titulo} guia={guia}>
        <div className="row">
          <div className="col-md-3">
            {this.renderStepper()}
          </div>
          <div className="col-md-9">
            {this.renderContenidoPaso()}
          </div>
        </div>
        <style jsx="true">{`
          .stepper-vertical {
            position: relative;
            padding: 0;
          }
          .stepper-step {
            position: relative;
            padding-left: 45px;
            padding-bottom: 30px;
          }
          .stepper-step:last-child {
            padding-bottom: 0;
          }
          .stepper-circle {
            position: absolute;
            left: 0;
            top: 0;
            width: 32px;
            height: 32px;
            border-radius: 50%;
            background: #e7eaec;
            color: #888;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: bold;
            font-size: 14px;
            z-index: 2;
          }
          .stepper-step.active .stepper-circle {
            background: #1ab394;
            color: #fff;
          }
          .stepper-step.completed .stepper-circle {
            background: #1ab394;
            color: #fff;
          }
          .stepper-line {
            position: absolute;
            left: 15px;
            top: 32px;
            width: 2px;
            bottom: 0;
            background: #e7eaec;
          }
          .stepper-step.completed .stepper-line {
            background: #1ab394;
          }
          .stepper-label {
            padding-top: 5px;
          }
          .stepper-title {
            font-size: 14px;
            color: #888;
          }
          .stepper-step.active .stepper-title {
            color: #1ab394;
            font-weight: bold;
          }
          .stepper-step.completed .stepper-title {
            color: #1ab394;
          }
          .dropzone-area {
            border: 2px dashed #e7eaec;
            border-radius: 8px;
            padding: 40px 20px;
          }
          .tabla-scroll {
            max-height: 400px;
            overflow-y: auto;
            border: 1px solid #e7eaec;
            border-radius: 4px;
          }
          .tabla-scroll thead th {
            position: sticky;
            top: 0;
            background: #f5f5f6;
            z-index: 1;
          }
          .fa-margin {
            margin-right: 5px;
          }
        `}</style>
      </Autenticado>
    );
  }
}

export default BajasMasivas;
